import isEmail from 'validator/lib/isEmail';
import { SERIAL_NUMBER_REGEXP } from '../../config';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const schema = {
	'magixEmail': (value, state) => {
		if (!value) {
			return localize('required-field');
		}
		if (state.touched['magixEmail']) {
			if (!isEmail(value)) {
				return localize('discount-modal-email-invalid');
			}
		}
	},
	'productSerial': (value, state) => {
		if (state.touched['productSerial']) {
			if (!value) {
				return localize('required-field');
			}
			if (!SERIAL_NUMBER_REGEXP.test(value)) {
				return localize('discount-modal-serial-invalid-format');
			}			
		}
	}
};

export default schema;


// WEBPACK FOOTER //
// ./src/components/Modal/DiscountSchema.js